import React from "react";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
// import { makeStyles } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import GitHubIcon from "@mui/icons-material/GitHub";
import SvgIcon from "@mui/material/SvgIcon";
import CartoCosmosIcon from "../../assets/img/cartocosmos-logo.svg";

/**
 * Controls css styling for this component using js to css
 */
let css = {
  root: {
    backgroundColor: "#f8f9fa",
    maxHeight: 25,
    height: 25,
    color: "#343a40",
    textAlign: "center",
    "& hr": {
      //margin: theme.spacing(0, 1),
      height: 25
    },
    "& svg": {
      margin: "2px"
    },
    "& > *": {
      maxHeight: 25
    }
  },
  link: {
    fontSize: 12,
    fontWeight: "600px !important"
  }
};

export default function CreditsDisplay() {
  // const classes = useStyles();

  return (
    <>
      <Grid
        container            sx={css.root}
        alignItems="center"  alignContent="center"  justifyContent="flex-end"  wrap="nowrap"
      >
          <Typography style={{ fontSize: 12 }} variant="caption">
            <Link
              target="_blank"    rel="noopener"   href="https://cefns.nau.edu/capstone/projects/CS/2020/CartoCosmos-S20/"
              variant="caption"  color="inherit"  style={{ fontWeight: 600 }}
            >
              CartoCosmos
            </Link>
            {" "}
          </Typography>
          <SvgIcon
            style={{ color: "#343a40", top: 0, width: 90, height: 60, position: "relative" }}
            component={CartoCosmosIcon}        viewBox="200 200 550 400"
          />
      </Grid>
    </>
  );
}
